import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import Navigation from '../Components/Navigation';
import MobileNavigation from "../HaboCustom/Components/MobileNavigation";

const NavigationContainer = props => {
    let menuRef = useRef();
    const mobileBreakpoint = 1024;

    const resizeTimeout = useRef(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth < mobileBreakpoint);

    useEffect(() => {
        const onResize = () => {
            const newValue = window.innerWidth < mobileBreakpoint;
            if (isMobile === newValue) {
                return;
            }

            const headerEl = document.querySelector('.header.menu-open');
            if (headerEl) {
                headerEl.classList.remove('menu-open');
            }

            setIsMobile(window.innerWidth < mobileBreakpoint);
        }

        const resizeEventHandler = () => {
            if (resizeTimeout.current) clearTimeout(resizeTimeout.current);
            resizeTimeout.current = window.setTimeout(onResize, 1000);
        }

        window.addEventListener('resize', resizeEventHandler);
        return () => window.removeEventListener('resize', resizeEventHandler);
    }, [isMobile]);

    return <>
        <Navigation {...props} {...{ isMobile, menuRef }} />
        <MobileNavigation menuRef={menuRef} />
    </>;
}

const mapStateToProps = state => {
    let siteConfig = window.__litium.site || { logo: null, altLogo: null };

    return {
        links: state.navigation.contentLinks,
        cat: 'wa',
        currentLevel: 0,
        ...siteConfig
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavigationContainer)
